var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_121",
    "data-name": "Group 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.576,
    height: 24.029,
    viewBox: "0 0 28.576 24.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 28.576,
    height: 24.029,
    fill: "#39b5b4",
    stroke: "#f2f2f2",
    strokeWidth: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M28.576,17.582a2.767,2.767,0,0,0-2.307-2.724A11.926,11.926,0,0,0,16.96,3.882l.98-1.443L16.185,0H12.391L10.636,2.439l1,1.476a11.761,11.761,0,0,0-2.6.941H2.288V6.531H6.547q-.309.27-.6.561a12.246,12.246,0,0,0-.915,1.026H0V9.791H3.916a11.794,11.794,0,0,0-.724,1.586H1.284v1.675H2.71a12,12,0,0,0-.235,1.782A2.767,2.767,0,0,0,0,17.582v2.4H2.014a2.86,2.86,0,1,0,5.2,0h14.14a2.86,2.86,0,1,0,5.2,0h2.014ZM12.679,2.467l.57-.792h2.077l.57.792L15.11,3.624c-.245-.015-.491-.023-.739-.023q-.452,0-.9.033Zm1.693,2.809a10.255,10.255,0,0,1,10.217,9.544H4.155A10.254,10.254,0,0,1,14.372,5.276M5.8,21.168a1.186,1.186,0,1,1-1.186-1.186A1.187,1.187,0,0,1,5.8,21.168m19.344,0a1.186,1.186,0,1,1-1.186-1.186,1.187,1.187,0,0,1,1.186,1.186m1.756-2.86H1.674v-.726a1.09,1.09,0,0,1,1.089-1.088h23.05A1.09,1.09,0,0,1,26.9,17.582Z",
    fill: "#39b5b4",
    stroke: "#f2f2f2",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellImg);
export default __webpack_public_path__ + "static/media/bellImg.9a7b5b98da99b0b3966150d9bbdf7d61.svg";
export { ForwardRef as ReactComponent };